import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Pasadena, CA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Pasadena can take 2–6 months. For Caltech researchers, JPL engineers, and San Gabriel Valley families, that timeline is simply not viable when travel windows are determined by conference schedules or academic calendars.",
  },
  {
    q: "Can Caltech or JPL employees get a passport fast for last-minute international travel?",
    a: "Absolutely. Caltech faculty and JPL engineers are among our most common client types in the Pasadena area. Conference invitations and international collaboration trips often arrive 2–4 weeks before departure. We regularly process expedited renewals and new passports for researchers and engineers on compressed timelines. Contact us as soon as travel is confirmed — do not wait until the week before your flight.",
  },
  {
    q: "What is the nearest passport agency to Pasadena?",
    a: "The Los Angeles Passport Agency is located at 11000 Wilshire Blvd, Los Angeles, CA 90024 — about 25 miles southwest of Pasadena. While it is geographically close, getting a same-day appointment there is not guaranteed and often requires flexibility with your schedule. Fast Passport Center provides the same results without the uncertainty: start online, ship overnight from Pasadena, and receive your passport within your selected timeframe.",
  },
  {
    q: "Can San Gabriel Valley residents from Arcadia or San Marino use this service?",
    a: "Yes — Arcadia, San Marino, Monrovia, Temple City, Alhambra, and all surrounding San Gabriel Valley communities are fully within our service area. Since we operate remotely, your exact location does not affect processing speed. Ship your documents overnight from anywhere in the SGV and we handle the rest.",
  },
  {
    q: "Do I need to make an in-person visit to get an expedited passport?",
    a: "For most renewals, no. You can start online, follow the checklist, and ship documents overnight. First-time applicants and children (under 16) must visit an acceptance clerk in person to submit their initial application. We provide a personalized checklist with exact Pasadena-area acceptance clerk locations so you know exactly where to go and what to bring.",
  },
  {
    q: "What passport photo locations are near Pasadena?",
    a: "CVS, Walgreens, FedEx Office, and UPS Store locations throughout Pasadena and the San Gabriel Valley offer passport photos. We provide exact State Department photo specifications after you start your order so you get it right the first time.",
  },
  {
    q: "How does Fast Passport Center compare to going to the LA Passport Agency myself?",
    a: "The LA Passport Agency only serves travelers with urgent travel within 14 days and requires a documented appointment. Getting an appointment there — even with nearby access — is not guaranteed. Fast Passport Center provides predictable expedited processing with a 2–9 business day option for most travelers, reserved agency submission, and professional document review — without the appointment uncertainty.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function PasadenaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Pasadena and San Gabriel Valley travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}